import type { BoxProps } from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';

import { ElementType, forwardRef } from 'react';

import Box from '@mui/material/Box';

import TwemojiFlagChina from '@/components-v2/icons/TwemojiFlagChina';
import TwemojiFlagUnitedKingdom from '@/components-v2/icons/TwemojiFlagUnitedKingdom';
import { iconifyClasses } from './classes';

// ----------------------------------------------------------------------

export type FlagIconProps = BoxProps & {
  code?: string;
};

export const FlagIcon = forwardRef<HTMLSpanElement, FlagIconProps>(({ code, className, sx, ...other }, ref) => {
  const baseStyles: SxProps<Theme> = {
    width: 26,
    height: 20,
    flexShrink: 0,
    overflow: 'hidden',
    borderRadius: '5px',
    alignItems: 'center',
    display: 'inline-flex',
    justifyContent: 'center',
    bgcolor: 'background.neutral',
  };

  if (!code) {
    return null;
  }

  // 映射国家代码到 twemoji 图标
  const getFlagIcon = (countryCode: string): ElementType => {
    switch (countryCode.toUpperCase()) {
      case 'CN':
        return TwemojiFlagChina;
      case 'GB':
        return TwemojiFlagUnitedKingdom;
      default:
        return TwemojiFlagUnitedKingdom;
    }
  };

  return (
    <Box
      ref={ref}
      component="span"
      className={iconifyClasses.flag.concat(className ? ` ${className}` : '')}
      sx={{ ...baseStyles, ...sx }}
      {...other}
    >
      <Box component={getFlagIcon(code)} width={26} height={20} />
    </Box>
  );
});
